import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import ProjectCard from "../Projects/ProjectCards";

const Experience = () => {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Professional <strong className="purple"> background </strong>
        </h1>
        <Row style={{ paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={"https://web.lio.io/static/media/LioL.e3711c64.svg"}
              isBlog={false}
              title="Lio"
              description="Led React Js, React Native, and Redux-driven flagship product development, fostering user engagement through cross-team collaboration. Designed and implemented critical cloud functions on Google Cloud Platform, boosting performance and scalability. Transformed user input into user-friendly features, elevating satisfaction metrics."
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={"https://proedge.co/assets/logo.png"}
              isBlog={false}
              title="ProEdge"
              description="Developed company's official mobile application using React Native and improved performance with Redux Toolkit. Backend services were built with NodeJS and ExpressJS. Led the design of the front-end data and presentation layer. Project serving over 800 institutions and has received over 5,000 downloads on the Google Play Store."
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={
                "https://dframe.org/wp-content/uploads/2023/01/dframe-removebg-preview-1-3.png"
              }
              title="D Frame"
              description="As a Full Stack Developer at D Frame, I played a crucial role in building a decentralized data ecosystem that empowers individuals to monetize their personal data with privacy. I honed my skills in developing smart contracts and implemented cutting-edge Web3 technologies to support businesses with valuable data. My goal was to contribute to the re-imagination of the data economy."
            />
          </Col>
        </Row>

        <Row style={{ paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={"https://www.travokarma.com/logo.png"}
              title="TravOkarma"
              description="Inspired by a love of travel and the feedback of global travelers, I was part of creating a community that drives meaningful impact both externally and internally through engaging experiences. I led the front-end development using the latest methodologies and best practices in React Native, including developing the Fund Raisers features for travelers. I also contributed to code reviews and offered constructive feedback to elevate the codebase's overall quality."
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Experience;
